import { AboutUsComponent } from './Modules/Homepage/about-us/about-us.component';
import { AppointmentComponent } from './Common/client-appointment/appointment/appointment.component';
import { BlogsComponent } from './Modules/Blogs/blogs.component';
import { ChildMarriagePlanningComponent } from './Modules/Planning/child-marriage-planning/child-marriage-planning.component';
import { ChildrenEducationPlanningComponent } from './Modules/Planning/children-education-planning/children-education-planning.component';
import { ContactUsComponent } from './Modules/Homepage/contact-us/contact-us.component';
import { DisclosureComponent } from './Modules/Homepage/disclosure/disclosure.component';
import { EarlyRetirementPlanningComponent } from './Modules/Planning/early-retirement-planning/early-retirement-planning.component';
import { FinancialPlanningComponent } from './Modules/Planning/financial-planning/financial-planning.component';
import { HealthInsuranceComponent } from './Modules/Planning/health-insurance/health-insurance.component';
import { PrivacyPolicyComponent } from './Modules/Homepage/privacy-policy/privacy-policy.component';
import { RetirementPlanningComponent } from './Modules/Planning/retirement-planning/retirement-planning.component';
import { Routes } from '@angular/router';
import { SingleBlogComponent } from './Modules/Blogs/single-blog.component';
import { TermAndConditionComponent } from './Modules/Homepage/term-and-condition/term-and-condition.component';
import { TermPlanComponent } from './Modules/Planning/term-plan/term-plan.component';
import { WebiComponent } from './Modules/Homepage/webinar/webi/webi.component';
import { WebinarComponent } from './Modules/Homepage/webinar/webinar.component';
import { WebsiteTemplateComponent } from './Common/website-template/website-template.component';

export const routes: Routes = [
  // Main routes
  { path: '', component: WebsiteTemplateComponent },
  { path: 'about', component: AboutUsComponent },
  { path: 'contact', component: ContactUsComponent },

  // Blog routes
  { path: 'blog', component: BlogsComponent },
  { path: 'blog/:id', component: SingleBlogComponent },
  { path: 'blog/category/:id', component: SingleBlogComponent },

  // Policy routes
  { path: 'privacy', component: PrivacyPolicyComponent },
  { path: 'disclosure', component: DisclosureComponent },
  { path: 'term', component: TermAndConditionComponent },

  // Webinar routes
  { path: 'webinar', component: WebinarComponent },
  { path: 'webi', component: WebiComponent },

  // Service routes
  { path: 'financial-planning', component: FinancialPlanningComponent },
  { path: 'retirement-planning', component: RetirementPlanningComponent },
  { path: 'early-retirement-planning', component: EarlyRetirementPlanningComponent },
  { path: 'children-education-planning', component: ChildrenEducationPlanningComponent },
  { path: 'child-marriage-planning', component: ChildMarriagePlanningComponent },
  { path: 'health-insurance', component: HealthInsuranceComponent },
  { path: 'term-plan', component: TermPlanComponent },

  // Appointment route
  { path: 'appointment', component: AppointmentComponent },

  // Fallback route
  { path: '**', redirectTo: '' }
];

// This is your main Angular routing configuration
// It defines how your application handles client-side navigation
// Used for browser-based routing
